import { useCallback, useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import { AUDIENCE_DETAILS_QUERY } from 'audiences-data/queries/getAudienceDetailsQuery';
/**
 * Fetches or returns cached audience name for given id.
 * If not given an id, skips fetching on mount.
 */
const useAudienceName = (audienceId, options = {}) => {
  var _data$audienceDetails;
  const {
    refetch,
    data,
    loading,
    error
  } = useQuery(AUDIENCE_DETAILS_QUERY, Object.assign({
    variables: {
      audienceId: audienceId
    },
    fetchPolicy: 'cache-first',
    skip: !audienceId
  }, options));
  const fetchAudienceName = useCallback(id => refetch({
    audienceId: id
  }), [refetch]);
  const audienceName = data === null || data === void 0 || (_data$audienceDetails = data.audienceDetails) === null || _data$audienceDetails === void 0 ? void 0 : _data$audienceDetails.name;
  return useMemo(() => ({
    audienceName,
    fetchAudienceName,
    loading,
    error
  }), [audienceName, fetchAudienceName, loading, error]);
};
export default useAudienceName;